import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from './pages/AppLayout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import View3D from './Components/threeD/View3D';
import DemoDashboard from './Components/threeD/dashboard/DemoDashboard';
import Dashboard from './Components/threeD/dashboard/Dashboard';
import View3DNew from './Components/threeD/View3DNew';


function App() {
  return (
    <div className="App">
            <ToastContainer />
      <BrowserRouter>
        <Routes>
            <Route path="/360" element={<AppLayout/>} />
            <Route path="/3d" element={<View3D common={true}/>} />
            <Route path="/3d/v2" element={<View3DNew />} />
            <Route path='/3d/dashboard' element={<Dashboard/>} />
            <Route path='/3d/demo' element={<DemoDashboard/>} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
